<div class="p-6">
    <h2 class="text-xl font-semibold mb-4">{{ isEditMode ? 'Edit Info Box' : 'Add Info Box' }}</h2>

    <form [formGroup]="infoBoxForm" class="space-y-4">
        <!-- Icon Name -->
        <div>
            <label for="iconName" class="mb-2 font-medium flex justify-between"
                ><span>Icon Name*</span>
                <a class="text-blue-500 underline" href="https://fonts.google.com/icons" target="_blank">Material Icons</a></label
            >
            <input
                id="iconName"
                type="text"
                pInputText
                formControlName="iconName"
                class="w-full"
                placeholder="e.g., home, check, star"
                [ngClass]="{ 'ng-invalid ng-dirty': infoBoxForm.get('iconName')?.invalid && infoBoxForm.get('iconName')?.touched }"
            />
            <small class="text-red-500" *ngIf="infoBoxForm.get('iconName')?.invalid && infoBoxForm.get('iconName')?.touched">
                Icon name is required
            </small>
        </div>

        <!-- Title -->
        <div>
            <label for="title" class="block mb-2 font-medium">Title*</label>
            <input
                id="title"
                type="text"
                pInputText
                formControlName="title"
                class="w-full"
                placeholder="Enter title"
                [ngClass]="{ 'ng-invalid ng-dirty': infoBoxForm.get('title')?.invalid && infoBoxForm.get('title')?.touched }"
            />
            <small class="text-red-500" *ngIf="infoBoxForm.get('title')?.invalid && infoBoxForm.get('title')?.touched">
                Title is required
            </small>
        </div>

        <!-- Description -->
        <div>
            <label for="description" class="block mb-2 font-medium">Description*</label>
            <textarea
                id="description"
                pInputTextarea
                formControlName="description"
                rows="4"
                class="w-full"
                placeholder="Enter description"
                [ngClass]="{
                    'ng-invalid ng-dirty border-red-500': infoBoxForm.get('description')?.invalid && infoBoxForm.get('description')?.touched
                }"
            ></textarea>
            <small class="text-red-500" *ngIf="infoBoxForm.get('description')?.invalid && infoBoxForm.get('description')?.touched">
                Description is required
            </small>
        </div>

        <!-- Action Buttons -->
        <div class="flex justify-end gap-2 mt-6">
            <p-button label="Cancel" severity="secondary" (click)="onCancel()" styleClass="p-button-text"></p-button>
            <p-button label="Save" icon="pi pi-check" (click)="onSave()"></p-button>
        </div>
    </form>
</div>
